/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 29/07/13
 * Time: 17:10
 * To change this template use File | Settings | File Templates.
 */


angular.module('FlexyBeautyApp.services').
factory('BookingServiceView',["ActivityView","BookingService","DayHrData","DayPrData","ActivityData","Period","PhysicalResourceData",
        function (ActivityView,BookingService,DayHrData,DayPrData,ActivityData,Period,PhysicalResourceData){
    //BookingServiceView inherit from ActivityView

    var  BookingServiceView = function (bookingService,bsIndex,bookingView)
    {
        //bookingService : model object
        //bsIndex : index inside booking
        //bookingView : bookingView parent
        this.bsIndex = bsIndex; //model index on booking
        this.bookingView = bookingView;
        this.serviceView = null;
        this.isPackage = false;
        this.originalPrice = 0
        this.price = 0;
        this.priceHT = 0;
        this.discountPercent = 0;
        this.hrRequest = false;
        this.aDayHrView = null;
        this.aDayPrView = null;
        this.secondariesADayHrsNeededView = []; // contains [{ aDayHrView : obj }]
        this.secondariesADayPrsNeededView = []; // contains [{ aDayHrView : obj }]
        this.billPosition =bsIndex+1;//position inside booking ->
        this.subBsView=[]; // subBooking services View
        this.cureItemToServiceUsageView = null;
        ActivityView.call(this,bookingService); //call ActivityView.constructor -> call BookingServiceView.loadDataFrom
    };

    BookingServiceView.prototype = Object.create(ActivityView.prototype);//inherit functions from ActivityView

    //override  ActivityView.prototype.loadDataFrom
    BookingServiceView.prototype.loadDataFrom = function(bookingService)
    {
        //Call super function ActivityView.prototype.loadDataFrom
        ActivityView.prototype.loadDataFrom.call(this,bookingService);

        //Manage specifics fields of BookingServiceView
        this.price = bookingService.price;
        this.updatePriceHT();
        this.isPackage = bookingService.isPackage;
        this.hrRequest = bookingService.hrRequest;
        this.originalPrice = bookingService.originalPrice;
        this.discountPercent = bookingService.discountPercent;
        if (bookingService.service)
           this.serviceView =  this.bookingView.domainView.getServiceView(bookingService.service);
        if (this.isPackage)
        {
            this.subBsView = [];
            for (var i=0;i<bookingService.subBookingServices.length;i++)
            {
                var bsV =new BookingServiceView(bookingService.subBookingServices[i],this.bsIndex,this.bookingView);
                bsV.pTView = this.pTView;
                this.subBsView.push(bsV);
            }

        }
    };

    BookingServiceView.prototype.copyDataTo = function(bookingService)
    {
        if (bookingService)
        {
            bookingService.setPeriod(this.period);
            bookingService.label = this.label;
            bookingService.service = this.serviceView.getModel();
            bookingService.isPackage = this.isPackage;
            bookingService.hrRequest = this.hrRequest;
            bookingService.price = this.price;
            bookingService.originalPrice = this.originalPrice;
            bookingService.discountPercent = this.discountPercent;

            var day,hr,pr,dayHr,dayPr;
            if (!this.isPackage) {
                if (this.aDayHrView && this.aDayHrView.hrView) {
                    day = this.aDayHrView.aDayView.getModel();
                    hr = this.aDayHrView.hrView.getModel();
                    if (day && hr) {
                        dayHr = this.aDayHrView.getModel();
                        if (!dayHr)
                            dayHr = day.createAndAddDayHr(hr.id)
                        bookingService.dayHr = dayHr;

                        for (var i = 0; i < bookingService.secondariesDayHrs.length; i++)
                            bookingService.secondariesDayHrs[i].removeActivity(bookingService);
                        bookingService.secondariesDayHrs = [];
                        for (var i = 0; i < this.secondariesADayHrsNeededView.length; i++) {
                            if (this.secondariesADayHrsNeededView[i].aDayHrView) {
                                dayHr = this.secondariesADayHrsNeededView[i].aDayHrView.getModel();
                                if (!dayHr) // create dayHr
                                {
                                    hr = this.secondariesADayHrsNeededView[i].aDayHrView.hrView.getModel();
                                    day = this.secondariesADayHrsNeededView[i].aDayHrView.plgDayView.getModel()
                                    dayHr = day.createAndAddDayHr(hr.id);
                                    this.secondariesADayHrsNeededView[i].aDayHrView.dayHrIndex = DayHrData.getIndexOf(dayHr);
                                }
                                dayHr.addActivity(bookingService, false);

                            }
                        }
                    }
                }
                if (this.aDayPrView && this.aDayPrView.prView) {
                    day = this.aDayPrView.aDayView.getModel();
                    pr = this.aDayPrView.prView.getModel();
                    if (day && pr) {
                        dayPr = this.aDayPrView.getModel();
                        if (!dayPr)
                            dayPr = day.createAndAddDayPr(pr.id, this.aDayPrView.prUnitId);
                        bookingService.dayPr = dayPr;
                        for (var i = 0; i < bookingService.secondariesDayPrs.length; i++)
                            bookingService.secondariesDayPrs[i].removeActivity(bookingService);
                        bookingService.secondariesDayPrs = [];
                        for (var i = 0; i < this.secondariesADayPrsNeededView.length; i++) {
                            if (this.secondariesADayPrsNeededView[i].aDayPrView) {
                                dayPr = this.secondariesADayPrsNeededView[i].aDayPrView.getModel();
                                if (!dayPr) // create dayPr
                                {
                                    pr = this.secondariesADayPrsNeededView[i].aDayPrView.prView.getModel();
                                    day = this.secondariesADayPrsNeededView[i].aDayPrView.plgDayView.getModel()
                                    dayPr = day.createAndAddDayPr(pr.id, this.secondariesADayPrsNeededView[i].aDayPrView.prUnitId);
                                    this.secondariesADayPrsNeededView[i].aDayPrView.dayPrIndex = DayPrData.getIndexOf(dayPr);
                                }
                                dayPr.addActivity(bookingService, false);

                            }
                        }
                    }
                }
            }

        }
    };
    BookingServiceView.prototype.moveToPeriodStart = function(start)
    {
        if (this.period)
            this.period.moveToStart(start);
    };
    BookingServiceView.prototype.updatePriceHT = function(){
        if (this.bookingView && this.bookingView.domainView)
            this.priceHT = Math.round((100/(100+this.bookingView.domainView.getDefaultVatTax()) * this.price)*100)/100;
    };
    BookingServiceView.prototype.updatePrice = function(parentBs)
    {
        if (this.cureItemToServiceUsage)
            return;
        var oriPrice = this.originalPrice;
        var discount = 0;
        var discountPercent =this.discountPercent;
        if (parentBs!==undefined && parentBs!=null)//use parentBs discount percent
            discountPercent = parentBs.discountPercent;
        if (this)
        if (discountPercent && typeof discountPercent ==='string')
        {
            discountPercent = discountPercent.replace(",",".").replace(" ","");
            discountPercent = parseFloat(discountPercent);
        }
        if (discountPercent!=0)
            discount = Math.round((discountPercent *  oriPrice / 100)*100)/100;

        if ((oriPrice-discount)!=this.price)
        {
            this.price = (oriPrice-discount);
            this.updatePriceHT();
            if (this.bookingView)
            {
                this.bookingView.updateGlobalBookingDataFromBS();
                if (this.bookingView.saleView)
                {
                    this.bookingView.saleView.resetPayments();
                    this.bookingView.saleView.calculateSaleFields();
                }
            }
        }
        for(var i = 0; i < this.subBsView.length; i++){
            this.subBsView[i].updatePrice(this);
        }
    };


    BookingServiceView.prototype.updateService = function ()
    {
        if (!this.cureItemToServiceUsageView)
            this.setService(this.serviceView);
    };

    BookingServiceView.prototype.addDiscount = function (discount) {
        let discountTab;
        if (!this.cureItemToServiceUsageView && discount) {
            discountTab = [this.discountPercent, discount];
            this.discountPercent = this.calculateDiscount(discountTab);
            this.updatePrice();
        }
    };

    BookingServiceView.prototype.calculateDiscount = function (discountTab) {
        let totalDiscount = 0;
        for (let i = 0; i < discountTab.length; i++) {
            if (!isNaN(discountTab[i])) {
                totalDiscount = (1 - (1 - totalDiscount / 100) * (1 - discountTab[i] / 100)) * 100;
            }
        }
        return totalDiscount;
    };

    BookingServiceView.prototype.updateCureItemAfterReload = function (cureItemToServiceView) {
        if (this.cureItemToServiceUsageView && this.cureItemToServiceUsageView.cureItemToServiceView)
            this.cureItemToServiceUsageView.cureItemToServiceView.removeCureItemToServiceUsageView(this.cureItemToServiceUsageView);

        if (cureItemToServiceView)
            cureItemToServiceView.addUsageFromBookingServiceView(this); //new one //this.cureItemToServiceUsageView is updated


    };

    BookingServiceView.prototype.setService = function(serviceView,duration)
    {
        this.serviceView = serviceView;
        if (serviceView!=null)
        {
            this.label = serviceView.label;
            this.isPackage = serviceView.isPackage;
            if (serviceView.hasInternetPrice)//on customer site only
            {
                this.price = serviceView.internetPrice;
                this.discountPercent = serviceView.internetDiscountPercent;
            }
            else
            {
                this.price = serviceView.price;
                this.discountPercent = 0;
            }
            this.originalPrice = serviceView.price;
            this.updatePriceHT();
            if (!this.period)
                this.period = new Period();

            if (this.isPackage)
            {
                var start =  this.period.start;
                this.subBsView=[] ;
                for (var i=0;i<serviceView.subServicesView.length;i++)
                {
                    var bsView = new BookingServiceView(null,-1,this.bookingView);
                    bsView.setPeriodStart(start);
                    bsView.setService(serviceView.subServicesView[i]);
                    this.subBsView.push(bsView);
                    start =bsView.period.end;
                }
            }
            else
            {
                this.secondariesPlgDayHrsNeededView = [];
                if (serviceView.nbHrsNeeded>1)
                    for (var i=1;i<serviceView.nbHrsNeeded;i++)
                        this.secondariesPlgDayHrsNeededView.push({plgDayHrView : null});
                this.secondariesPlgDayPrsNeededView = [];
                if (serviceView.nbPrsNeeded>1)
                    for (var i=1;i<serviceView.nbPrsNeeded;i++)
                        this.secondariesPlgDayPrsNeededView.push({plgDayPrView : null});

            }
            if (duration!==undefined && duration)
                this.setPeriodDuration(duration)
            else
                this.setPeriodDuration(serviceView.duration);
        }
    };

    BookingServiceView.prototype.isBookable = function (aDayView, aDayHrView, aListADayHrsView, aListADayPrsView) {
        let isBookable = true;
        if (this.isPackage) {
            for (let i = 0; i < this.subBsView.length; i++) {
                isBookable = isBookable && this.subBsView[i].hasAvailability(aDayView, aDayHrView, aListADayHrsView, aListADayPrsView);
            }
        } else {
            isBookable = this.hasAvailability(aDayView, aDayHrView, aListADayHrsView, aListADayPrsView);
        }
        return isBookable;

    };
    BookingServiceView.prototype.hasAvailability = function (aDayView, aDayHrView, aListADayHrsView, aListADayPrsView) {
        let isBookable = true;
        if (aDayView && this.serviceView) {
            isBookable = this.hasHrAvailability(aDayView, aDayHrView, aListADayHrsView)
                    && this.hasPrAvailability(aDayView, aListADayPrsView);
        }
        return isBookable;
    };

    BookingServiceView.prototype.hasPrAvailability = function (aDayView, aListADayPrsView) {
        let isBookable = true;
        let aDayPrViewOk;
        let index;
        let listADayPrsView = aListADayPrsView.slice(0);//clone
        this.secondariesADayPrsNeededView = [];
        if (this.serviceView.nbPrsNeeded != 0) {
            if (aListADayPrsView.length == 0) {
                return false;
            }
            aDayPrViewOk = aDayView.getFirstAvailableDayRView(listADayPrsView, this);//No specifc  pr needed
            if (aDayPrViewOk) {
                index = listADayPrsView.indexOf(aDayPrViewOk);
                if (index != -1) {
                    listADayPrsView.splice(index, 1);   //remove it to try next
                }
                this.aDayPrView = aDayPrViewOk;
            } else {
                return false;
            }
            for (let nbP = 1; nbP < this.serviceView.nbPrsNeeded; nbP++) {
                aDayPrViewOk = aDayView.getFirstAvailableDayRView(listADayPrsView, this);
                this.secondariesADayPrsNeededView.push({aDayPrView: aDayPrViewOk});
                index = listADayPrsView.indexOf(aDayPrViewOk);
                if (index != -1) {
                    listADayPrsView.splice(index, 1);   //remove it to try next
                }
                isBookable = isBookable && (aDayPrViewOk != null)
            }
            if (this.aDayPrView) {//push pr  in first of the list

                index = aListADayPrsView.indexOf(this.aDayPrView);
                if (index != -1) {
                    aListADayPrsView.splice(index, 1);   //remove it to try next
                    aListADayPrsView.unshift(this.aDayPrView);
                }
            }
        }
        return isBookable;
    };

    BookingServiceView.prototype.hasHrAvailability = function(aDayView, aDayHrView, aListADayHrsView, chooseHr) {
        let isBookable = true;
        let aDayHrViewOk;
        let listADayHrsView = aListADayHrsView.slice(0);//clone
        let index;
        this.secondariesADayHrsNeededView = [];
        if (this.serviceView.nbHrsNeeded != 0) {
            if (aListADayHrsView.length == 0) {
                return false;
            }
            if (aDayHrView) {
                aDayHrViewOk = aDayView.getFirstAvailableDayRView([aDayHrView], this);
            } else {
                aDayHrViewOk = aDayView.getFirstAvailableDayRView(listADayHrsView, this);//No specifc hr needed
            }
            if (aDayHrViewOk) {
                index = listADayHrsView.indexOf(aDayHrViewOk);
                if (index != -1) {
                    listADayHrsView.splice(index, 1);   //remove it to try next
                }
                this.aDayHrView = aDayHrViewOk;
            } else {
                return false;
            }
            for (let nbH = 1; nbH < this.serviceView.nbHrsNeeded; nbH++) {
                aDayHrViewOk = aDayView.getFirstAvailableDayRView(listADayHrsView, this);
                this.secondariesADayHrsNeededView.push({aDayHrView: aDayHrViewOk});
                index = listADayHrsView.indexOf(aDayHrViewOk);
                if (index != -1) {
                    listADayHrsView.splice(index, 1);   //remove it to try next
                }
                isBookable = isBookable && (aDayHrViewOk != null)
            }
            if (this.aDayHrView) {//push hr in first of the list

                index = aListADayHrsView.indexOf(this.aDayHrView);
                if (index != -1) {
                    aListADayHrsView.splice(index, 1);   //remove it to try next
                    aListADayHrsView.unshift(this.aDayHrView);
                }
            }
        }
        return isBookable;
    }

    BookingServiceView.prototype.addTime = function(time) {
        if (this.period)
            this.period.addTime(time);
        if (this.isPackage)
            for (var i=0;i<this.subBsView.length;i++)
                this.subBsView[i].addTime(time);
    };

    BookingServiceView.prototype.isAvailableForSecondaries = function(aDayView,assignedADayHrView,assign)
    {
        if (!this.serviceView)
            return false;
        if (this.serviceView.nbHrsNeeded>1)
        {
            var listADayHrsView = aDayView.aDayHrsView.slice(0);
            //Remove current one
            var index =  listADayHrsView.indexOf(assignedADayHrView);
            if (index!=-1)
                listADayHrsView.splice(index,1);
            var aDayHrView;
            for (var i=0;i<this.secondariesADayHrsNeededView.length;i++)
            {
                aDayHrView = aDayView.getFirstAvailableDayRView(listADayHrsView,this);
                if (aDayHrView)
                {
                    index = listADayHrsView.indexOf(aDayHrView);
                    if (index!=-1)
                        listADayHrsView.splice(index,1);//remove
                    if (assign)
                        this.secondariesADayHrsNeededView[i].aDayHrView = aDayHrView;
                }
                else
                   return false;

            }
        }
        if (this.serviceView.nbPrsNeeded>0)
        {
            var listADayPrsView = aDayView.aDayPrsView.slice(0);
            var aDayPrView;
            aDayPrView = aDayView.getFirstAvailableDayRView(listADayPrsView,this);
            if (aDayPrView)
            {
                index = listADayPrsView.indexOf(aDayPrView);
                if (index!=-1)
                    listADayPrsView.splice(index,1);//remove
                if (assign)
                    this.aDayPrView = aDayPrView;
            }
            else
                return false;
            for (var i=0;i<this.secondariesADayPrsNeededView.length;i++)
            {
                aDayPrView = aDayView.getFirstAvailableDayRView(listADayPrsView,this);
                if (aDayPrView)
                {
                    index = listADayPrsView.indexOf(aDayPrView);
                    if (index!=-1)
                        listADayPrsView.splice(index,1);//remove
                    if (assign)
                        this.secondariesADayPrsNeededView[i].aDayPrView = aDayPrView;
                }
                else
                    return false;

            }
        }
        return true;

    };
    BookingServiceView.prototype.linkToBooking = function(bookingService)
    {
        var newBooking = this.bookingView.getModel();
        if (bookingService.booking && newBooking!==bookingService.booking)//remove
            bookingService.booking.removeBookingService(bookingService);

        if (newBooking)//Force add because removed by booking.updateModel
            newBooking.addBookingService(bookingService);
    };
    BookingServiceView.prototype.updateModel = function(linkToBooking)
    {
        var bookingService = this.getModel();
        if (!bookingService)//must create model
        {
            bookingService = new BookingService();
            this.actIndex = ActivityData.getIndexOf(bookingService);
        }
        this.copyDataTo(bookingService);
        if (linkToBooking)
        {
            this.linkToBooking(bookingService);

            if (this.isPackage)
            {
                bookingService.subBookingServices = [];
                for (var i=0;i<this.subBsView.length;i++)
                {
                    var subBs = this.subBsView[i].updateModel(false);
                    if (subBs)
                        bookingService.addSubBs(subBs);
                }
            }

        }
        return bookingService;
    };


    return BookingServiceView;
}])


// WEBPACK FOOTER //
// ./js/services/customerSite/views/BookingServiceView.js